import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@material-ui/core';

const ConfirmDialog = ({
  open, onClose, onConfirm, text, title,
}) => (
  <Dialog
    disableEscapeKeyDown
    disableBackdropClick
    onClose={onClose}
    maxWidth="xs"
    aria-labelledby="confirmation-dialog-title"
    open={open}
  >
    <DialogTitle id="simple-dialog-title">{title}</DialogTitle>
    <DialogContent>
      {text}
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} color="primary">
        Нет
      </Button>
      <Button onClick={onConfirm} color="primary">
        Да
      </Button>
    </DialogActions>
  </Dialog>
);

ConfirmDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  text: PropTypes.string,
  title: PropTypes.string,
};

ConfirmDialog.defaultProps = {
  open: false,
  text: 'Вы действительно хотите удалить?',
  title: 'Удаление',
};

export default ConfirmDialog;
